(function () {
  'use strict';

  // Guard against double-loading if the script is included twice.
  if (window.__txomeCartTieredDiscountProgressLoaded) return;
  window.__txomeCartTieredDiscountProgressLoaded = true;

  const ROOT_SELECTOR = '[data-cart-tiered-discount-progress]';
  const FILL_SELECTOR = '.cart-tiered-discount-progress__fill';
  const CONTEXT_ATTR = 'data-progress-context';
  const PERCENT_ATTR = 'data-progress-percent';

  const state = (window.__txomeCartTieredDiscountProgressState =
    window.__txomeCartTieredDiscountProgressState || {});

  function animate(el) {
    const fill = el.querySelector(FILL_SELECTOR);
    if (!fill) return;

    // Theme has a global `div:empty { display:none; }` in `base.css`.
    // Our fill element can be empty in older cached HTML, which makes it disappear.
    // Ensure it's never `:empty` so CSS can't hide it.
    if (fill.childNodes.length === 0) {
      const spacer = document.createElement('span');
      spacer.setAttribute('aria-hidden', 'true');
      fill.appendChild(spacer);
    }
    // Extra safety: inline style beats any theme CSS.
    fill.style.display = 'block';

    const raw = el.getAttribute(PERCENT_ATTR);
    let percent = Number.parseFloat(raw);
    if (!Number.isFinite(percent)) {
      // Fallback for older markup: try inline width like "37%".
      percent = Number.parseFloat(fill.style.width);
    }
    if (!Number.isFinite(percent)) return;

    const target = Math.max(0, Math.min(100, percent));

    const ctx = el.getAttribute(CONTEXT_ATTR) || 'default';
    const prev = state[ctx];
    const start = Number.isFinite(prev) ? Math.max(0, Math.min(100, prev)) : target;

    // Set to previous (or target on first render), then animate to target when it changes.
    fill.style.width = `${start}%`;
    void fill.offsetWidth; // Force layout so the transition runs for the next width change.
    requestAnimationFrame(() => {
      fill.style.width = `${target}%`;
    });

    state[ctx] = target;
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(animate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      // Defer to allow theme code to replace the cart sections first.
      requestAnimationFrame(initAll);
    });
  } else if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => initAll());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
